module.exports = __webpack_public_path__ + "img/T7451-IL.29f480f6.jpg";